// src/utils/omit-undefined.ts
function omitUndefined(obj) {
  return Object.keys(obj).reduce((acc, key) => {
    if (obj[key] === "undefined") {
      return acc;
    }
    return {
      ...acc,
      [key]: obj[key]
    };
  }, {});
}

export {
  omitUndefined
};
//# sourceMappingURL=chunk-RVDAKL7Q.mjs.map